import { roundOff } from '../../../Components/helper';

export default function useFPSalesHooks() {
  const caluculateFPSSales = async (state) => {
    let fpSalesUnits = 0;
    let fpSalesValue = 0;
    const { totalPWS, fpRos, stores, rrpValue } = state;
    const fpRopsValue = Number(fpRos?.value) || 0;
    const storesValue = Number(stores?.value) || 0;
    const rrp = Number(rrpValue?.value) || 0;
    if (totalPWS && fpRopsValue > 0 && storesValue > 0) {
      fpSalesUnits = roundOff(totalPWS * fpRopsValue * storesValue, 0);
      if (fpSalesUnits > 0 && rrp > 0) {
        fpSalesValue = fpSalesUnits * rrp;
      }
    }
    for (const channelKey in state?.channels) {
      // Ensure the channel object exists and has the required properties
      if (state?.[channelKey]?.channelType === 'buyDependent' && state?.[channelKey]?.unitType === 'manual' && state[channelKey]) {
        // Ensure the unit object exists before setting its value
        if (!state[channelKey].unit) {
          state[channelKey].unit = {};
        }
        // Calculate and set the unit value with proper null checks
        const ratio = Number(state[channelKey]?.unit?.ratio || 0);
        state[channelKey].unit.value = Math.round((Number(fpSalesUnits) * ratio) / 100);
      }
    }
    return {
      fpSalesUnits: Math.round(fpSalesUnits),
      fpSalesValue,
    };
  };
  return { caluculateFPSSales };
}
